import { ISetNavigationLink, ISetNavigationMenuVisibility } from './actions';
import { TNavigationLinkType } from '../../types';

export interface INavigationLinksState {
  links: TNavigationLinkType[];
  isMenuVisible: boolean;
}

const defaultState: INavigationLinksState = {
  isMenuVisible: false,
  links: [],
};

export type Action = ISetNavigationLink | ISetNavigationMenuVisibility;

export function navigationLinksReducer(
  state: INavigationLinksState = defaultState,
  action: Action,
): INavigationLinksState {
  switch (action.type) {
    case 'ISetNavigationLink':
      return {
        ...state,
        links: [...state.links, action.link],
      };
    case 'ISetNavigationMenuVisibility':
      return {
        ...state,
        isMenuVisible: action.isMenuVisible,
      };
    default:
      return state;
  }
}
